import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../Components/Header/Header";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark, faPaperclip, faFileArrowDown, faPaperPlane, faTimes, faFilter, faFileLines, faEllipsisVertical, faPencilAlt, faCircle, faUser, faLocationDot } from '@fortawesome/free-solid-svg-icons';

import { Link } from 'react-router-dom';


import AddImport from './Common/AddImport'; 
import AddExport from './Common/AddExport'; 

const AddShipmentRecords = () => {

    const type = localStorage.getItem("AddShipmentType");

    return (
        <>
            <div className="">
                {/* {console.log('handlerList', handlerList)} */}
                <Header page_type='fsm' logo_url='/ForwarderShipments/ShipmentRecords' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <Link to={localStorage.getItem('ccbackUrl')} className='stk_back'> <FontAwesomeIcon icon={faArrowLeft} /> Back</Link>
                        <div className='mb-3 mt-3'>
                            {type === "export" ? <AddExport /> : <AddImport />}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddShipmentRecords;